import config from 'react-global-configuration';

config.set({
    'rainbow-api-url': window.env.API_URL,
    'pdf-api-url': window.env.PDF_API_URL,
    'pdf-api-new-url': window.env.PDF_API_NEW_URL,
    'pdf-display-url': window.env.PDF_DISPLAY_URL,
    'authority-url': window.env.IDENTITY_URL,
    'reservation-url': window.env.R_URL
});

export default config;



// WEBPACK FOOTER //
// ./src/config.js